import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import { Api } from 'further-types/companies';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

type CompanyShareholdingsQueryKey = [
  'company-shareholdings',
  Api.GetInvesteeShareholdingsQuery,
];

async function fetchCompanyShareholdings({
  queryKey,
}: {
  queryKey: CompanyShareholdingsQueryKey;
}) {
  const [, params] = queryKey;

  const { data } = await api.get<{ data: Api.GetInvesteeShareHoldingsResult }>(
    `investee/${params.companyId}/shareholdings`,
    {
      params,
    },
  );

  return data.data;
}

function useCompanyShareholdings(params: Api.GetInvesteeShareholdingsQuery) {
  return useQuery<
    Api.GetInvesteeShareHoldingsResult,
    Error,
    Api.GetInvesteeShareHoldingsResult,
    CompanyShareholdingsQueryKey
  >({
    queryKey: ['company-shareholdings', params],
    queryFn: fetchCompanyShareholdings,
    placeholderData: keepPreviousData,
    staleTime: QUERY_STALE_TIME_MS,
  });
}

export default useCompanyShareholdings;
